export default __webpack_public_path__ + "static/media/about.7940d41a.png";